(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function(){
  const galleries = document.querySelectorAll('.pm-gallery');
  galleries.forEach(function(g){
    const thumbs = g.querySelector('[data-pm-thumbs]');
    if(!thumbs) return;

    // Slide switching
    g.addEventListener('click', function(e){
      const btn = e.target.closest('.pm-thumb');
      if(!btn) return;
      g.querySelectorAll('.pm-thumb').forEach(t=>t.classList.remove('is-active'));
      btn.classList.add('is-active');
      const idx = btn.dataset.index;
      g.querySelectorAll('.pm-slide').forEach(s=>s.classList.remove('is-active'));
      const slide = g.querySelector('.pm-slide[data-index="'+idx+'"]');
      if(slide) slide.classList.add('is-active');
    });

    // Chevrons
    const up = g.querySelector('.pm-chevron--up');
    const down = g.querySelector('.pm-chevron--down');
    if(!(up && down)) return;

    const mqDesktop = window.matchMedia('(min-width:750px)');
    const isMobile = () => !mqDesktop.matches;

    function needChevrons(){
      return isMobile()
        ? thumbs.scrollWidth > thumbs.clientWidth + 4   // small tolerance for iOS rounding
        : thumbs.scrollHeight > thumbs.clientHeight + 1;
    }


    function updateVisibility(){
      const needed = needChevrons();
      up.hidden = down.hidden = !needed;
      if(!needed) return;

      if(isMobile()){
        const max = Math.max(0, thumbs.scrollWidth - thumbs.clientWidth - 1);
        up.disabled = thumbs.scrollLeft <= 0;
        down.disabled = thumbs.scrollLeft >= max;
      }else{
        const max = Math.max(0, thumbs.scrollHeight - thumbs.clientHeight - 1);
        up.disabled = thumbs.scrollTop <= 0;
        down.disabled = thumbs.scrollTop >= max;
      }
    }

    function pageStep(){
      const thumb = g.querySelector('.pm-thumb');
      if(!thumb) return 100;
      const rect = thumb.getBoundingClientRect();
      const styles = getComputedStyle(thumbs);
      const gap = parseFloat(styles.gap || styles.rowGap || 0);
      const visible = isMobile()
        ? Math.max(1, Math.floor(thumbs.clientWidth  / (rect.width  + gap)))
        : Math.max(1, Math.floor(thumbs.clientHeight / (rect.height + gap)));
      return visible * (isMobile() ? (rect.width + gap) : (rect.height + gap));
    }

    up.addEventListener('click', ()=>{
      isMobile()
        ? thumbs.scrollBy({ left: -pageStep(), behavior:'smooth' })
        : thumbs.scrollBy({ top:  -pageStep(), behavior:'smooth' });
    });
    down.addEventListener('click', ()=>{
      isMobile()
        ? thumbs.scrollBy({ left:  pageStep(), behavior:'smooth' })
        : thumbs.scrollBy({ top:   pageStep(), behavior:'smooth' });
    });

    thumbs.addEventListener('scroll', updateVisibility, { passive:true });
    window.addEventListener('resize', updateVisibility);
    mqDesktop.addEventListener('change', updateVisibility);
    setTimeout(updateVisibility, 0);


        // --- Mobile overscroll "bounce" effect on the horizontal thumbnails ---
    const touchOpts = { passive: false };
    let startX = 0, startScrollLeft = 0, pulling = false;

    function resetBounce(){
      thumbs.style.transition = 'transform 200ms ease-out';
      thumbs.style.transform = 'translateX(0)';
      setTimeout(()=>{ thumbs.style.transition = ''; }, 220);
    }

    thumbs.addEventListener('touchstart', (e)=>{
      if (!isMobile()) return;
      const t = e.changedTouches[0];
      startX = t.clientX;
      startScrollLeft = thumbs.scrollLeft;
      pulling = false;
      thumbs.style.transition = 'transform 0s';
    }, touchOpts);

    thumbs.addEventListener('touchmove', (e)=>{
      if (!isMobile()) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - startX;

      const atLeft  = thumbs.scrollLeft <= 0;
      const atRight = Math.ceil(thumbs.scrollLeft + thumbs.clientWidth) >= thumbs.scrollWidth;

      // When dragging past the edges, apply a resisted translate to simulate rubber band
      if ((atLeft && dx > 0) || (atRight && dx < 0)) {
        e.preventDefault(); // prevent the page from scrolling
        pulling = true;
        const resist = dx * 0.35; // resistance factor
        thumbs.style.transform = `translateX(${resist}px)`;
      }
    }, touchOpts);

    thumbs.addEventListener('touchend', ()=>{
      if (!isMobile()) return;
      if (pulling) resetBounce();
      pulling = false;
    }, touchOpts);

    thumbs.addEventListener('touchcancel', ()=>{
      if (!isMobile()) return;
      if (pulling) resetBounce();
      pulling = false;
    }, touchOpts);

  });
})();
  } catch(e) { console.error(e); }
})();

})();
